export class Academic {
  AcademicCode;
  CDesc;
  EDesc;
  constructor() {
    this.AcademicCode = "";
    this.CDesc = "";
    this.EDesc = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/Academic.js